import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngxs/store';

import { UserResponse } from '@smarthead-api/models/user-response';

import { UserLogoModule } from '@client/app/widgets/user-logo/user-logo.module';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { UserLogOut } from '../../../../state/app.actions';
import { UserUtils } from '../../../../utils/user-utils';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-user',
  templateUrl: './main-nav-user.component.html',
  styleUrl: './main-nav-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MainNavService],
  imports: [
    NgClass,
    AsyncPipe,
    MatMenuModule,
    UserLogoModule,
    TranslocoPipe
  ]
})
export class MainNavUserComponent {
  #routerLinkCreatorService = inject(RouterLinkCreatorService);
  #store = inject(Store);
  #mainNavService = inject(MainNavService);

  @Input() loggedUser: UserResponse | undefined;

  itemClassList$ = this.#mainNavService.activeUrl$.pipe(map(activeUrl => (activeUrl === 'user' ? ['active'] : [])));
  isSuperAdmin$ = this.#mainNavService.isSuperAdmin$;

  get userTitle() {
    return UserUtils.generateUserName(this.loggedUser);
  }

  navigateToSettings() {
    if (this.loggedUser) {
      this.#routerLinkCreatorService.navigateToLoggedUser(this.loggedUser, 'ADMIN');
    }
  }

  logout(): void {
    this.#store.dispatch(new UserLogOut());
  }
}
